<template>
  <b-col cols="alto" class="sidebar">
    <img
      style="width: 10rem; padding-left: 1rem; padding-right: 1rem"
      alt="Vue logo"
      src="../assets/images/logo.png"
    />
    <p class="img-text">Aggregator Portal</p>
    <ul class="sidebar-menu">
      <li v-for="nav in navs" :key="nav.url" class="mb-2" active-class="active">
        <router-link
          :to="nav.url"
          class="py-1 px-8 sideNav block text-sm"
          active-class="active"
        >
          <svg
            width="24"
            height="24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              :d="nav.icon"
              fill="currentColor"
            />
          </svg>
          <span style="padding-top: 0.25rem; padding-left: 0.625rem">
            {{ nav.title }}</span
          >
        </router-link>
      </li>
      <button @click="logoutUser" class="absolute-bottom">Logout</button>
    </ul>
  </b-col>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Sidebar",
  components: {},
  data() {
    return {
      navs: [
        {
          url: "/dashboard",
          title: "Dashboard",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
        {
          url: "/pinpad-transactions",
          title: "Pinpad Transactions",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
        {
          url: "/pos-transactions",
          title: "POS Transactions",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
        {
          url: "/account-opening",
          title: "Account Opening",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
        {
          url: "/top-agents",
          title: "Top Agents",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
        {
          url: "/agent-list",
          title: "Agent List",
          icon:
            "M8.013 2H4.976A2.986 2.986 0 002 4.996V8.06a2.986 2.986 0 002.976 2.995h3.037c1.645 0 2.976-1.343 2.976-2.995V4.996A2.986 2.986 0 008.013 2zM4.976 3.395h3.037c.872 0 1.58.715 1.58 1.6V8.06c0 .884-.708 1.6-1.58 1.6H4.976a1.59 1.59 0 01-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zM19.026 2h-3.04a2.986 2.986 0 00-2.975 2.996V8.06c0 1.652 1.331 2.995 2.976 2.995h3.038C20.67 11.055 22 9.712 22 8.06V4.996C22 3.343 20.67 2 19.025 2zm-3.04 1.395h3.04c.87 0 1.579.715 1.579 1.6V8.06c0 .884-.71 1.6-1.58 1.6h-3.038c-.872 0-1.58-.716-1.58-1.6V4.996c0-.886.708-1.6 1.58-1.6zm-11.01 9.55h3.037c1.646 0 2.976 1.342 2.976 2.996v3.063A2.986 2.986 0 018.013 22H4.976A2.986 2.986 0 012 19.005V15.94a2.986 2.986 0 012.976-2.996zm3.037 1.395H4.976a1.59 1.59 0 00-1.58 1.601v3.063c0 .886.708 1.6 1.58 1.6h3.037a1.59 1.59 0 001.58-1.6v-3.063a1.59 1.59 0 00-1.58-1.6zm11.012-1.395h-3.038c-1.646 0-2.976 1.342-2.976 2.996v3.063A2.986 2.986 0 0015.987 22h3.038C20.67 22 22 20.657 22 19.005V15.94c0-1.653-1.33-2.996-2.975-2.996zm-3.038 1.395h3.038c.871 0 1.58.715 1.58 1.601v3.063c0 .886-.71 1.6-1.58 1.6h-3.038a1.59 1.59 0 01-1.58-1.6v-3.063a1.59 1.59 0 011.58-1.6z",
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      logout: "user/logout",
    }),
    logoutUser() {
      this.logout().then(
        window.localStorage.setItem("clickedLogout", "true"),
        this.$router.replace({ name: "Login" })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  --tw-shadow: 0 1px 3px 0 hsla(0, 0%, 0%, 0.1),
    0 1px 2px 0 hsla(0, 0%, 0%, 0.06);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 hsla(0, 0%, 0%, 0)),
    var(--tw-ring-shadow, 0 0 hsla(0, 0%, 0%, 0)), var(--tw-shadow);
  background: hsl(0, 0%, 100%);
  padding: 1rem 0 !important;
}
.sidebar-menu {
  padding-top: 3.7rem;
}
ul {
  list-style: none;
}
li > a {
  display: flex;
  align-items: center;
  border-left: 3px solid transparent;
  padding: 1rem 1.18rem;
  width: 100%;
  font-size: 1rem;
  text-decoration: none;
  color: var(--gray-dark);
  margin-bottom: 1.5rem;
}
li > a:hover,
.active {
  color: var(--primary);
  border-left: 3px solid var(--primary);
  background: hsla(349, 85%, 56%, 0.05);
}
.absolute-bottom {
  position: absolute;
  bottom: 0;
  border: none;
  background: transparent;
  color: var(--primary);
  padding: 0.5rem 1rem;
  margin-left: 1rem;
}
.absolute-bottom:hover {
  background: hsla(349, 85%, 56%, 0.05);
}
.img-text {
  color: hsl(349, 85%, 56%);
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>
